import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/app';

import { CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter } from 'react-router-dom';
import DefaultTheme from "./themes/default-theme.tsx";

import AppStore from './stores/app-store';
import { Provider } from "react-redux";

import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://35c92ca6ab4e4cbf5fea023364cbfacd@o4509209445531648.ingest.de.sentry.io/4509209453330512",
  sendDefaultPii: true
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={DefaultTheme}>
      <CssBaseline />
      <BrowserRouter>
        <Provider store={AppStore}>
          <App />
        </Provider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
)
